import { render, staticRenderFns } from "./home-search.vue?vue&type=template&id=2387dd63&scoped=true&"
import script from "./home-search.vue?vue&type=script&lang=js&"
export * from "./home-search.vue?vue&type=script&lang=js&"
import style0 from "./home-search.vue?vue&type=style&index=0&id=2387dd63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387dd63",
  null
  
)

export default component.exports